import React from "react";
import { priceString } from "../lib/formatters";
import { Row, Col, Button, Spin, Icon, Alert } from "antd";
import styled from "styled-components";
import { QuoteResponse } from "../lib/model/QuoteResponse";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

const PriceLabel = styled.span`
  font-size: 28px;
  line-height: 1.21;
  color: #386ee8;
  font-weight: 600;
`;

const HintLabel = styled.span`
  font-size: 11px;
  color: rgba(6, 26, 50, 0.56);
  font-weight: 300;
  display: inline-block;
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-direction: column-reverse;
  height: 100%;
`;

type Props = {
  isLoading: boolean;
  quote?: QuoteResponse;
  continueEnabled: boolean;
  onContinueClicked: () => void;
  error?: Error;
};

export class PriceDisplay extends React.Component<Props> {
  render() {
    const { isLoading, quote } = this.props;
    return (
      <Wrapper>
        <Row type="flex" justify="space-between" style={{ flex: 1 }}>
          <Col span="auto">
            <Spin indicator={<Icon type="loading" spin />} spinning={isLoading}>
              <PriceLabel>
                {quote ? `${priceString(quote.fullCost.net)}` : "- €"}
              </PriceLabel>
            </Spin>
          </Col>
          <Col span="auto">
            <ButtonWrapper>
              <Button
              disabled={!this.props.continueEnabled}
              style={{
                backgroundColor: this.props.continueEnabled
                ? "#386ee8"
                : "#dedede",
                boxShadow: "0 3px 6px 0 rgba(0, 0, 0, 0.25)",
                fontWeight: 300,
                color: this.props.continueEnabled ? "#ffffff" : "#061a32",
                fontSize: "14px",
                lineHeight: 2.29,
                width: "137px",
                height: "36px",
                borderRadius: 0,
                border: "none"
              }}
              onClick={this.props.onContinueClicked}
              >
              Zur Übersicht
              </Button>
            </ButtonWrapper>
          </Col>
        </Row>
        {this.props.error && (
          <div style={{ marginTop: 15 }}>
            {(this.props.error as any).response &&
            (this.props.error as any).response.status === 422 ? (
              <Alert
                message="Eine Buchung mit diesen Parametern ist nur über unsere Hotline möglich: 040 874 091 21. Wir freuen uns auf Ihren Anruf."
                type="info"
              />
            ) : (
              <Alert message={this.props.error.message} type="error" showIcon />
            )}
          </div>
        )}
        <Row type="flex" justify="space-between">
          <Col span={24} style={{ marginTop: 10 }}>
            {quote && (
              <HintLabel>
                {`Inkl. ${quote.includedWaitingTime} Minuten Wartezeit. Weitere Informationen in unseren `}
                <a
                  href="https://forward-cargo.com/terms#waiting-times"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  AGB
                </a>
                .
              </HintLabel>
            )}
          </Col>
        </Row>
      </Wrapper>
    );
  }
}
